<script lang="ts">
	import DefaultButton from '../../../../basic/buttons/DefaultButton.svelte';
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import Modal from '../../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../../basic/modal/ModalHeader.svelte';
	import DefaultSwitch from '../../../../basic/switch/DefaultSwitch.svelte';
	import type { SettingDocumentType } from '../../../../types/BasicTypes';
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import SettingDocumentTypes from './SettingDocumentTypes.svelte';

	interface Props {
		header: string;
		usedForCopy: boolean;
		overrideWithDefaultValues?: boolean;
		onModalClose?: () => void;
		onSelectionChanged: (item: SettingDocumentType) => void;
	}

	let {
		header,
		usedForCopy,
		overrideWithDefaultValues = $bindable(true),
		onModalClose = undefined,
		onSelectionChanged
	}: Props = $props();

	const LOCAL_STORAGE_OVERRIDE_KEY = 'override-on-copy-document';

	onMount(() => {
		let savedValue = localStorage.getItem(LOCAL_STORAGE_OVERRIDE_KEY);

		//Load the key
		overrideWithDefaultValues = savedValue == null ? true : savedValue === 'true';
	});

	function handleCheckChanged(value: boolean) {
		if (value) {
			localStorage.setItem(LOCAL_STORAGE_OVERRIDE_KEY, 'true');
		} else {
			//Delete the key again
			localStorage.setItem(LOCAL_STORAGE_OVERRIDE_KEY, value.toString());
		}
	}
</script>

<Modal onModalClose={() => onModalClose?.()}>
	{#snippet header()}
		<ModalHeader text={header} />
	{/snippet}
	{#snippet content()}
		<div class="w-[1000px] max-w-[80vw] h-[70vh]">
			<SettingDocumentTypes showDetailOnClick={false} {onSelectionChanged} />
		</div>
	{/snippet}
	{#snippet footer()}
		<div>
			<div class="flex justify-end gap-4">
				{#if usedForCopy}
					<div class="grow ml-4 flex items-center gap-2">
						<DefaultSwitch
							bind:checked={overrideWithDefaultValues}
							propertyName="overrideWithDocumentTypeValues"
							onCheckChanged={handleCheckChanged}
						/>
						<p class="text-sm">{$_('document_list_view.lbl_copy_override')}</p>
						<IconButton
							size="small"
							onClick={() => {
								window.open(import.meta.env.VITE_RELEASE_NOTES_URL + '#dokstandard', '_blank');
							}}
							iconName="info"
						/>
					</div>
				{/if}
				<!-- Buttons -->
				<DefaultButton
					secondary={true}
					onClick={() => {
						onModalClose?.();
					}}
					text={$_('general.lbl_cancel')}
				/>
			</div>
		</div>
	{/snippet}
</Modal>
